/**
 * Safely extract an error message from an unknown caught value.
 * Use in catch blocks instead of `catch (error: any)`.
 *
 * @example
 * ```ts
 * try { ... }
 * catch (error: unknown) {
 *   toast.error(getErrorMessage(error, 'Operation failed'));
 * }
 * ```
 */
export function getErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (
    error !== null &&
    typeof error === 'object' &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  ) {
    return (error as Record<string, unknown>).message as string;
  }
  return fallback;
}
